import { useMemo } from 'react';

import { orderBy } from 'lodash';
import { Controller, useFormContext } from 'react-hook-form';

import useUserHook from 'hooks/useUserHook';

import { useProjectTreeStore } from 'store/projectContract.store';

import { QueryResponse as Risk } from 'api/queries/getRisk.query';
import { useQueryGetStoredTags } from 'api/queries/getStoredTags.query';

import SelectWithCreate from 'components/common/SelectWithCreate/SelectWithCreate';
import { useSelectWithCreateHook } from 'components/common/SelectWithCreate/SelectWithCreateHook';

import classes from 'components/widgets/RiskRegister/components/RiskRegisterRoutes/components/Details/Details.module.scss';

export const Tags = () => {
    const { customerId } = useUserHook();
    const { project, contract } = useProjectTreeStore();
    const { data: tags } = useQueryGetStoredTags({
        enabled: true,
        customerId,
        projectId: project?.id,
        contractId: contract?.id,
    });
    const { setValue, watch, control } = useFormContext<Risk>();

    const options = useMemo<ISelectOption<string>[]>(
        () =>
            tags
                ? orderBy(
                      tags.map((item) => ({ label: item.name, value: item.name })),
                      [(item: any) => item['label'].toLowerCase()],
                      ['asc'],
                  )
                : [],
        [tags],
    );

    const value = useMemo(() => {
        const value = watch('tags');
        if (value) {
            return value.map((item) => ({ label: item.name, value: item.name }));
        } else {
            return [];
        }
    }, [watch('tags'), options]);

    const { inputValue, onInputChange, onChange } = useSelectWithCreateHook({
        onChangeCallback: (value) =>
            setValue(
                'tags',
                value.map((item) => ({ name: item.value.trim() })),
                { shouldDirty: true },
            ),
    });

    return (
        <div className={classes.selectWrapper}>
            <div className={classes.title}>Tags:</div>
            <div className={classes.content}>
                <Controller
                    render={({ field }) => (
                        <SelectWithCreate
                            {...field}
                            value={value}
                            onChange={onChange}
                            options={options}
                            id={'cardModalTags'}
                            isMulti={true}
                            isClearable={true}
                            inputValue={inputValue}
                            onInputChange={onInputChange}
                        />
                    )}
                    name={`tags`}
                    control={control}
                />
            </div>
        </div>
    );
};
